"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TikTokDeployment = void 0;
var TikTokDeployment;
(function (TikTokDeployment) {
    let state;
    (function (state) {
        state["PENDING"] = "pending";
        state["OUTREACHING"] = "outreaching";
        state["OUTREACHED"] = "outreached";
        state["VIEWED"] = "viewed";
        state["ACCEPTED"] = "accepted";
        state["RUNNING"] = "running";
        state["ADJUSTMENT_APPROVAL"] = "adjustment_approval";
        state["PAYMENT_PROCESSING"] = "payment_processing";
        state["OUTREACH_TIMEOUT"] = "outreach_timeout";
        state["OUTREACH_REJECTED"] = "outreach_rejected";
        state["CANCELED"] = "canceled";
        state["FAILED_TO_MEET_GOALS"] = "failed_to_meet_goals";
        state["COMPLETED"] = "completed";
        state["ABUSE_IDENTIFIED"] = "abuse_identified";
    })(state = TikTokDeployment.state || (TikTokDeployment.state = {}));
})(TikTokDeployment = exports.TikTokDeployment || (exports.TikTokDeployment = {}));
